import React from "react";
import { Link } from "react-scroll";
import { heroImg } from '../assets';

function Hero() {
  return (
    <div
      className="hero min-h-screen relative"
      style={{
        backgroundImage: `url(${heroImg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div className="hero-overlay bg-gradient-to-b from-primary-900/80 to-primary-950/90"></div>
      <div className="hero-content text-center text-white relative z-10">
        <div className="max-w-2xl">
          <h1 className="mb-8 text-6xl font-bold animate-fade-in-down">
            Zajedno stvaramo <span className="text-primary-200">svjetliju</span> budućnost.
          </h1>
          <p className="mb-8 text-lg text-gray-200 leading-relaxed animate-fade-in-up">
            Kroz inovativna energetska rješenja i stručnu podršku, gradimo održivu 
            budućnost prilagođenu vašim potrebama.
          </p>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            duration={250}
            className="btn btn-primary bg-primary-600 hover:bg-primary-700 border-none text-white
                          cursor-pointer"
                     style={{ touchAction: 'manipulation' }}
          >
            Kontaktirajte nas
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Hero;